import { FiPrinter } from "react-icons/fi";
import { styles } from "./Scorecard.styles";
import type { MatchResults, PlayerScorecardDto } from "ScorecardModels";
import ScorecardHolesLayout from "./ScorecardHolesLayout";
import { HandicapMode, ScoringType } from "types/enums";
import { first } from "@/utils/object";

type ScorecardDetailsProps = {
  playerScorecard: PlayerScorecardDto[];
  scoringType?: number;
  matchResults?: MatchResults | undefined;
  handicapMode?: HandicapMode;
};

const ScorecardDetails: React.FC<ScorecardDetailsProps> = (props) => {
  const { playerScorecard, matchResults, scoringType, handicapMode } = props;

  return (
    <table className={styles.scorecardTable}>
      <tbody>
        <tr>
          <td colSpan={2}>
            <div className="flex justify-between">
              <div className="flex flex-row"></div>
              <div className="flex flex-col pt-2"></div>
            </div>
            <div className="flex flex-row px-4 w-full"></div>
          </td>
        </tr>

        <tr>
          <td colSpan={2} className="pt-4">
            {(first(playerScorecard)?.holes.length ?? 0) > 0 ? (
              <ScorecardHolesLayout
                playerScorecard={playerScorecard}
                matchResults={matchResults}
                scrambleLeague={
                  scoringType && scoringType === ScoringType.SCRAMBLE
                    ? true
                    : false
                }
                handicapMode={handicapMode}
                showNetScore={handicapMode === HandicapMode.OFF ? false : true}
              />
            ) : (
              <div className="text-center">
                <span className="text-normal text-gray-700">
                  No scorecard data available
                </span>
              </div>
            )}
          </td>
        </tr>

        <tr>
          <td colSpan={2} className="align-right hidden">
            <button
              className={styles.scorecardPrintButton}
              onClick={window.print}
            >
              <FiPrinter /> Print
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  );
};
export default ScorecardDetails;
